// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"3f49c1b7","375":"befaea25","938":"d77c632e"}[chunkId] + ".chunk.js";
};